import { render, staticRenderFns } from "./HomeMedal.vue?vue&type=template&id=7c43e72e&"
import script from "./HomeMedal.vue?vue&type=script&lang=js&"
export * from "./HomeMedal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports